export default __webpack_public_path__ + "static/media/ranes3.8d5ea44e.jpg";